import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconZaixiankefu20pxRegular = function IconZaixiankefu20pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("g", {
      clipPath: "url(#clip0_7_1336)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.75 6.667a4.25 4.25 0 018.5 0v6.666a4.25 4.25 0 01-4.25 4.25.75.75 0 000 1.5 5.751 5.751 0 005.71-5.061 4.084 4.084 0 000-8.044 5.751 5.751 0 00-11.42 0 4.085 4.085 0 00.708 8.105H5a.75.75 0 00.75-.75V6.667zm-1.5 5.806V7.527a2.584 2.584 0 000 4.946zm11.5-4.946v4.946a2.584 2.584 0 000-4.946z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7_1336",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20",
          height: "20"
        })
      })
    })]
  }));
};
export default IconZaixiankefu20pxRegular;